import { Avatar } from "@mui/material";
import { useStyles } from "./RCAUserWithAvatar.styles";
import { IRCAUserWithAvatar } from "./RCAUserWithAvatarInterfaces";
import { useCharFit } from "hooks/useCharFit";
import { truncateLongText } from "utilities/utilities";

const RCAUserWithAvatar = ({ imageUrl, name, hideText, isObservation, truncateText = true }: IRCAUserWithAvatar) => {
    const classes = useStyles();
    const { cellRef, charsThatCanFit } = useCharFit();

    return (
        <div className={isObservation ? classes.mainWrapperObservations : classes.mainWrapper}>
            <Avatar className={classes.avatar} src={imageUrl} />
            {!hideText && (
                <div className={classes.text} ref={cellRef}>
                    {truncateText ? truncateLongText(name, charsThatCanFit) : name}
                </div>
            )}
        </div>
    );
};

export default RCAUserWithAvatar;
